import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="cookie-policy-container">
      <h1>Cookie Policy</h1>
      
      <section>
        <h2>What are cookies?</h2>
        <p>
          Cookies are small text files that are stored on your computer or mobile device when you visit a website.
          They allow the website to recognize your device and remember if you've been to the website before.
        </p>
      </section>
      
      <section>
        <h2>How we use cookies</h2>
        <p>
          SOPHIE uses cookies for several purposes, including:
        </p>
        <ul>
          <li><strong>Essential cookies:</strong> These are necessary for the website to function properly.</li>
          <li><strong>Analytics cookies:</strong> These help us understand how visitors interact with our website by collecting and reporting information anonymously.</li>
          <li><strong>Marketing cookies:</strong> These are used to track visitors across websites to allow publishers to display relevant and engaging advertisements.</li>
        </ul>
      </section>
      
      <section>
        <h2>Types of cookies we use</h2>
        <h3>Google Analytics</h3>
        <p>
          We use Google Analytics to analyze the use of our website. Google Analytics generates statistical 
          and other information about website use by means of cookies. The information generated relating to our 
          website is used to create reports about the use of the website.
        </p>
        
        <h3>Other cookies</h3>
        <p>
          We may use other cookies to enhance your experience on our website, including remembering your preferences and settings.
        </p>
      </section>
      
      <section>
        <h2>Managing cookies</h2>
        <p>
          Most web browsers allow you to manage your cookie preferences. You can set your browser to refuse cookies, 
          or to alert you when cookies are being sent. The help function within your browser should tell you how to do this.
        </p>
        <p>
          Please note that disabling cookies may affect the functionality of this and many other websites that you visit.
        </p>
      </section>
      
      <section>
        <h2>Changes to our cookie policy</h2>
        <p>
          Any changes we may make to our cookie policy in the future will be posted on this page.
        </p>
      </section>
      
      <section>
        <h2>Contact us</h2>
        <p>
          If you have any questions about our cookie policy, please contact us at <a href="mailto:hello@sophiedoc.ai">hello@sophiedoc.ai</a>.
        </p>
      </section>
    </div>
  );
};

export default CookiePolicy;